var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueSlider',_vm._b({attrs:{"value":_vm.value,"min":_vm.min,"max":_vm.max,"interval":_vm.step,"tooltip-formatter":_vm.formatter},on:{"change":_vm.onInput}},'VueSlider',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }